import MicroModal from 'micromodal';
import { gsap } from 'gsap';

MicroModal.init({
	openTrigger: 'data-modal-open',
	closeTrigger: 'data-modal-close',
	disableScroll: true,
	awaitOpenAnimation: true,
	awaitCloseAnimation: true,
	onShow: ( modal ) => {
		const overlay = modal.querySelector( '.modal-overlay' );
		const box = modal.querySelector( '.modal-box' );
		modal.setAttribute( 'aria-hidden', 'false' );
		gsap.fromTo( overlay,
			{ opacity: 0 },
			{ opacity: 1, duration: 0.3, ease: 'power2.out' }
		);
		gsap.fromTo( box,
			{ opacity: 0, y: -20 },
			{ opacity: 1, y: 0, duration: 0.4, ease: 'power2.out' }
		);
	},
	onClose: ( modal ) => {
		const overlay = modal.querySelector( '.modal-overlay' );
		const box = modal.querySelector( '.modal-box' );
		
		gsap.to( box, { opacity: 0, y: -20, duration: 0.3, ease: 'power2.in' } );
		gsap.to( overlay, { opacity: 0, duration: 0.3, ease: 'power2.in', onComplete: () => {
			modal.classList.remove( 'is-open' );
			modal.setAttribute( 'aria-hidden', 'true' );
		} } );
	},
});